import GavelIcon from '@mui/icons-material/Gavel';
import PeopleIcon from '@mui/icons-material/People';
import ReceiptIcon from '@mui/icons-material/Receipt';
import StarIcon from '@mui/icons-material/Star';
import { alpha, Box, Stack, Tooltip } from '@mui/material';
import { Contact, ContactWithBusiness } from 'lib/api/contacts/types';
import { BASE_COLORS } from 'lib/functions/const/colors';
import React from 'react';

type Props = {
  id: number;
  data: Contact[] | ContactWithBusiness[];
};

const ProfileCell = ({ id, data }: Props) => {
  const item = data.find((item) => item.id === id);
  if (!item) return null;
  const blue = BASE_COLORS.blue;
  const green = BASE_COLORS.green;
  const yellow = BASE_COLORS.yellow;
  const lightBlue = BASE_COLORS.lightBlue;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
      }}
    >
      <Stack direction="row" spacing={1}>
        <Tooltip placement="top" title="Representante legal">
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: '999px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: item.isLegalRepresentative
                ? alpha(blue, 0.16)
                : 'grey.50',
              border: '1px solid',
              borderColor: item.isLegalRepresentative
                ? alpha(blue, 0.6)
                : 'grey.200',
              fontSize: 18,
              cursor: 'default',
            }}
          >
            <GavelIcon
              fontSize="inherit"
              sx={{
                color: item.isLegalRepresentative ? blue : 'text.disabled',
              }}
            />
          </Box>
        </Tooltip>

        <Tooltip placement="top" title="Socio">
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: '999px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: item.isPartner ? alpha(green, 0.16) : 'grey.50',
              border: '1px solid',
              borderColor: item.isPartner ? alpha(green, 0.6) : 'grey.200',
              fontSize: 18,
              cursor: 'default',
            }}
          >
            <PeopleIcon
              fontSize="inherit"
              sx={{ color: item.isPartner ? green : 'text.disabled' }}
            />
          </Box>
        </Tooltip>

        <Tooltip placement="top" title="Contacto principal">
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: '999px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: item.selected ? alpha(yellow, 0.16) : 'grey.50',
              border: '1px solid',
              borderColor: item.selected ? alpha(yellow, 0.6) : 'grey.200',
              fontSize: 18,
              cursor: 'default',
            }}
          >
            <StarIcon
              fontSize="inherit"
              sx={{ color: item.selected ? yellow : 'text.disabled' }}
            />
          </Box>
        </Tooltip>

        <Tooltip placement="top" title="Notificaciones de facturación">
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: '999px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: item.invoicing ? alpha(lightBlue, 0.16) : 'grey.50',
              border: '1px solid',
              borderColor: item.invoicing ? alpha(lightBlue, 0.6) : 'grey.200',
              fontSize: 18,
              cursor: 'default',
            }}
          >
            <ReceiptIcon
              fontSize="inherit"
              sx={{ color: item.invoicing ? lightBlue : 'text.disabled' }}
            />
          </Box>
        </Tooltip>
      </Stack>
    </Box>
  );
};

export default ProfileCell;
